/**
 * @file  routes/baseConfig.ts
 * @description  defines base route configuration for shareable components
 * @author ogarcia (ozkary)
 *
 */

/**
 * @description add each route to component mappig below.
 */
const routes = [
  {
    path: ['/customer'],
    exact: true,
    component: 'Customer'
  },
  {
    path: ['/payment'],
    exact: true,
    component: 'Payment'
  },
  {
    path: ['/review'],
    exact: true,
    component: 'Review'
  },
  {
    path: ['/checkout'],
    exact: true,
    component: 'Checkout'
  },
  {
    path: ['/receipt'],
    exact: true,
    component: 'Receipt'
  },
  {
    path: ['/end'],
    exact: true,
    component: 'End'
  },
  {
    path: [],
    exact: false,
    component: 'NotFound'
  }
];

// export the route mapping
export default routes;

/**
 * list of restricted routes which require a session state to be able to visit them
 */
export const restrictedRoutes = ['/coverage', '/payment', '/checkout', '/customer', '/review'];

/**
 * Use this to check if a route path is in the restricted list of routes. T
 * @param name the current route path
 * @returns true if the route is restricted
 */
export const isRouteRestricted = async(path: string) : Promise<boolean> => {
  return restrictedRoutes.includes(path);
};
